function getEnvironment(env) {
    return env;
}

export default getEnvironment;
